import { fetchQuarterPopulationGrid, buildPopulationGridOverlays } from './portal-population-grid.js';

const source = 'qi-development-grid';
const fill = source + '-fill', line = source + '-line';
let active = false, data = null, generation = 0, boundMap = null;
const button = () => document.getElementById('qi-development-area');
const status = text => { const node = document.getElementById('qi-development-status'); if (node) node.textContent = text; };
function paint() {
  const map = window.qiDevelopmentMap;
  if (!map || !data) return;
  if (!map.getSource(source)) {
    if (!active || !map.isStyleLoaded()) return;
    map.addSource(source, { type: 'geojson', data });
    map.addLayer({ id: fill, source, type: 'fill', paint: { 'fill-color': ['coalesce', ['get', 'fill_color'], '#38bdf8'], 'fill-opacity': 0.62 } });
    map.addLayer({ id: line, source, type: 'line', paint: { 'line-color': '#475569', 'line-width': 0.65 } });
  } else map.getSource(source).setData(data);
  [fill, line].forEach(id => { if (map.getLayer(id)) map.setLayoutProperty(id, 'visibility', active ? 'visible' : 'none'); });
  if (active) {
    [fill, line].forEach(id => { if (map.getLayer(id)) map.moveLayer(id); });
    ['qi-layer-quarter_polygon', 'qi-layer-boundary_polygon'].forEach(id => { if (map.getLayer(id)) map.moveLayer(id); });
  }
}
function bindMap() {
  const map = window.qiDevelopmentMap;
  if (!map || boundMap === map) return;
  boundMap = map;
  map.on('style.load', paint);
  map.on('idle', () => { if (active && data && !map.getLayer(fill)) paint(); });
  paint();
}
function reset() {
  generation += 1; active = false;
  if (data) paint();
  data = null;
  const btn = button();
  if (btn) { btn.disabled = !window.qiDevelopmentContext?.proparcelValue; btn.setAttribute('aria-pressed', 'false'); btn.classList.remove('active'); }
  status('');
}
async function toggle() {
  const btn = button(), context = window.qiDevelopmentContext;
  if (!context?.proparcelValue || !window.qiDevelopmentMap) { status('Önce mahalle seçin.'); return; }
  active = !active;
  btn.setAttribute('aria-pressed', String(active)); btn.classList.toggle('active', active);
  if (!active) { paint(); status(''); return; }
  if (data) { paint(); return; }
  const token = ++generation;
  btn.disabled = true; status('Gelişim alanları yükleniyor…');
  try {
    const result = await fetchQuarterPopulationGrid({ proparcel_value: context.proparcelValue, quarter_id: context.quarterId });
    if (token !== generation) return;
    data = buildPopulationGridOverlays(result.cells)[0]?.data || { type: 'FeatureCollection', features: [] };
    bindMap(); paint();
    status(data.features.length ? `Gelişim alanları · ${result.year} · ${data.features.length.toLocaleString('tr-TR')} hücre` : 'Bu mahalle için nüfus grid verisi bulunamadı.');
  } catch (err) {
    if (token !== generation) return;
    active = false; btn.setAttribute('aria-pressed', 'false'); btn.classList.remove('active'); status(err.message || 'Gelişim alanları yüklenemedi.');
  } finally { if (token === generation) btn.disabled = false; }
}
const btn = button();
if (btn) {
  btn.addEventListener('click', toggle);
  window.addEventListener('qi-development-context', reset);
  window.addEventListener('qi-development-map', bindMap);
  reset(); bindMap();
}
